

//const  api_admin = 'http://www.localhost:8000/api/'

const  api_admin = 'http://www.api.ucpvirtual.com.br/api/'



export default {
    api_admin
}